import * as React from 'react';
export const arrowUpRightSvg = React.forwardRef(function arrowUpRightSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6 .875a.875.875 0 1 0 0 1.75h6.138L1.88 12.881a.875.875 0 1 0 1.24 1.239L13.375 3.862V10a.875.875 0 0 0 1.75 0V1.75a.875.875 0 0 0-.875-.875H6Z',
    }),
  );
});
arrowUpRightSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowUpRight = {
  category: 'icon',
  colorable: true,
  name: 'arrowUpRight',
  svg: arrowUpRightSvg,
};
